<template>
  <v-container fluid grid-list-xs pa-0>
    <v-layout row wrap fill-height class="text-xs-left">
      <v-flex xs12 sm3>
        <v-card color="box1-bg">
          <v-card-text class="white--text">
            <p class="headline pr-1 text-center">
              <v-icon dark left>mdi-currency-eur</v-icon>Financials
              <v-divider dark class="mt-1"></v-divider>
            </p>
            <p>
              <strong class="overline">Total Price:</strong>
              <v-spacer></v-spacer>
              <span class="headline">
                {{itinerary.totalPrice}}
                {{itinerary.currencyCode}}
              </span>
            </p>

            <p>
              <strong class="overline">Commission:</strong>
              <v-spacer></v-spacer>

              <span class="headline">
                {{itinerary.commission}}
                {{itinerary.currencyCode}}
              </span>
            </p>

            <p>
              <strong class="overline">Receipts:</strong>
              <v-spacer></v-spacer>
              <span class="headline">
                {{itinerary.paid}}
                {{itinerary.currencyCode}}
              </span>
            </p>
            <p>
              <strong class="overline">Balance Due:</strong>
              <v-spacer></v-spacer>
              <span class="headline">
                {{itinerary.balance}}
                {{itinerary.currencyCode}}
              </span>
            </p>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm3>
        <v-card color="box2-bg">
          <v-card-text class="white--text">
            <p class="headline pr-1 text-center">
              <v-icon dark left>mdi-information-outline</v-icon>Status
              <v-divider dark class="mt-1"></v-divider>
            </p>

            <p>
              <strong class="overline">Status:</strong>
              <v-spacer></v-spacer>
              <span class="headline">{{itinerary.bookingStatus}}</span>
            </p>
            <p>
              <strong class="overline">Internal Status:</strong>
              <v-spacer></v-spacer>
              <span class="headline">{{itinerary.internalStatus}}</span>
            </p>
            <p>
              <strong class="overline">Reference:</strong>
              <v-spacer></v-spacer>
              <span class="headline">{{itinerary.reference}}</span>
            </p>
            <p>
              <strong class="overline">Internal Ref:</strong>
              <v-spacer></v-spacer>
              <span class="headline">{{itinerary.internalReference}}</span>
            </p>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm3>
        <v-card color="box3-bg">
          <v-card-text class="white--text">
            <p class="headline pr-1 text-center">
              <v-icon dark left>mdi-file-find</v-icon>Booking Details
              <v-divider dark class="mt-1"></v-divider>
            </p>
            <p>
              <strong class="overline">Agent:</strong>
              <v-spacer />
              <span class="headline">{{itinerary.agentName}}</span>
            </p>
            <p>
              <strong class="overline">Client:</strong>
              <v-spacer></v-spacer>
              <span class="headline">{{itinerary.clientName}}</span>
            </p>
            <p>
              <strong class="overline">Passengers:</strong>
              <v-spacer></v-spacer>
              <span class="headline">{{passengers}}</span>
            </p>
            <p>
              <strong class="overline">Adults/Children/Infants:</strong>
              <v-spacer></v-spacer>
              <span
                class="headline"
              >{{itinerary.pax.adults}}/{{itinerary.pax.children}}/{{itinerary.pax.infants}}</span>
            </p>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm3>
        <v-card color="box4-bg">
          <v-card-text class="white--text">
            <p class="headline pr-1 text-center">
              <v-icon dark left>mdi-account</v-icon>Staff
              <v-divider dark class="mt-1"></v-divider>
            </p>

            <p>
              <strong class="overline">Created By:</strong>
              <v-spacer></v-spacer>
              <span class="headline">{{itinerary.createdBy.name}}</span>
            </p>
            <p>
              <strong class="overline">Created Date:</strong>
              <v-spacer></v-spacer>
              <span class="headline">{{ itinerary.createdAt | formatDate }}</span>
            </p>
            <p>
              <strong class="overline">Booked By:</strong>
              <v-spacer></v-spacer>
              <span class="headline">{{itinerary.bookedByName}}</span>
            </p>
            <p>
              <strong class="overline">Department:</strong>
              <v-spacer></v-spacer>
              <span class="headline">{{itinerary.department}}</span>
            </p>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "itinerary-details-header-info",
  props: {
    itinerary: {}
  },
  computed: {
    passengers() {
      let passengers = 0;
      if (this.itinerary) {
        passengers =
          this.itinerary.pax.adults +
          this.itinerary.pax.children +
          this.itinerary.pax.infants;
      }
      return passengers;
    }
  }
};
</script>

<style scoped>
.box1-bg {
  background: linear-gradient(to right top, #37474f, #78909c);
  min-height: 365px;
}
.box2-bg {
  background: linear-gradient(to right top, #00695c, rgb(0, 196, 196));
  min-height: 365px;
}
.box3-bg {
  background: linear-gradient(to right top, #4a148c, #8e24aa);
  min-height: 365px;
}
.box4-bg {
  background: linear-gradient(to right top, #1b5e20, #43a047);
  min-height: 365px;
}
</style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/ItineraryDetailsHeaderInfo.vue